<ng-container *ngFor="let template of templates">
  <ng-container [ngSwitch]="template.type">
    <lsb-headline-and-text *ngSwitchCase="'text'" [value]="template"></lsb-headline-and-text>
    <lsb-hint *ngSwitchCase="'hint'" [value]="template"></lsb-hint>
    <lsb-spacer *ngSwitchCase="'spacer'"></lsb-spacer>
    <lsb-illustration *ngSwitchCase="'illustration'" [value]="template"></lsb-illustration>
  </ng-container>
</ng-container>
